<div [ngClass]="alertClass" class="mb-2">
    <div [ngClass]="sizeClass" [innerHTML]="message"></div>
    <div class="col-xs-4" *ngIf="link != ''">
        <button mat-button color="primary" (click)="goToUrl()">Clique aqui</button>
    </div>    
</div>
